import React from 'react';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import { Modal } from '@components';

const HighGradeModal = ({ msg }) => {
    const {
        ReturnStore: { highGradeModalVisible, closeHighGradeModal },
    } = useStore();
    return (
        <Modal
            show={highGradeModalVisible}
            onHide={closeHighGradeModal}
            title={'優質擔保品定義'}
        >
            <div>
                <div className="border-0">
                    <div className="icon_fast mx-auto "></div>
                    <div className="d-flex flex-nowrap justify-content-between align-items-center">
                        僅提供優質擔保品可申請，優質擔保品為以下四種股票：
                        <br />
                        ①所有ETF股票 <br />
                        ②0050、0051、0056、006201之ETF成份股 <br />
                        ③信用指標TCRI 1~5之股票 <br />
                        ④20日均量1,000張以上之股票 <br />
                    </div>
                    <div className="btn_box d-flex flex-column-reverse flex-sm-row justify-content-center">
                        <button
                            className="btn_check btn rounded-pill text-white"
                            type="button"
                            onClick={() => {
                                closeHighGradeModal();
                            }}
                        >
                            確認
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default observer(HighGradeModal);
